import { Fragment, memo } from 'react';
import Accountholder from '../shared/accountholder-historical';
import Applicant from '../shared/applicant';
import Payment from '../shared/fragment-payment';

interface ElectoralFormProps {
  disabled?: boolean;
}

const ElectoralFormComponent = ({ disabled }: ElectoralFormProps): React.ReactElement => {
  return (
    <Fragment>
      <Payment />
      <Applicant disabled={disabled} />
      <Accountholder />
    </Fragment>
  );
};

ElectoralFormComponent.displayName = 'Electoral Form component';

const ElectoralForm = memo(ElectoralFormComponent);

export default ElectoralForm;
